import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "games-filter games-filter--mobile" }
const _hoisted_2 = { class: "games-filter__option" }
const _hoisted_3 = {
  key: 0,
  class: "games-filter__option-number games-filter__option-number--mobile"
}
const _hoisted_4 = {
  key: 0,
  class: "games-filter__option-dialog games-filter__option-dialog--sort"
}
const _hoisted_5 = { class: "games-filter__popup" }
const _hoisted_6 = { class: "games-filter__popup-footer" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "games-button__inner" }

import { useGamesGrid } from "@/games/composables/use-games-grid";
import GamesFilterCategoryOptions from "./games-filter-category-options.vue";
import DsButton from "@sazka/design-system/src/button/ds-button.vue";
import GamesSortOptions from "./games-sort-options.vue";
import { computed, nextTick, ref, watch } from "vue";
import { GamesFilterParameters } from "@/games/models/games-filter-parameters";
import { useBottomSheet } from "@/lotteries/category-page/composables/use-bottom-sheet";
import { GamesFilterType } from "@/games/models/games-filter-type";
import { GamesAnalytics } from "@/games/analytics/analytics-games";
import { GamesFilterCategory } from "@/games/models/games-filter-options";


export default /*@__PURE__*/_defineComponent({
  __name: 'games-filter-mobile',
  setup(__props) {

const { reloadWithFilter, getFilteredGamesCount, filterParameters, filterOptions, totalCount } = useGamesGrid();

const bottomSheet = useBottomSheet("#games-filter-bottom-sheet", {
    keepOpenTolerance: 20,
    speedToForceClose: 3000,
    headerHeight: 64,
    safeBottomHeight: 400,
});
const bottomSheetRef = ref<HTMLElement | null>(null);

const isFilterOpen = ref(false);
const isSortOpen = ref(false);
const activeFilterCount = computed(() => {
    let filteredCount = 0;
    if (filterParameters.value.manufacturers.length) filteredCount += filterParameters.value.manufacturers.length;
    if (filterParameters.value.genres.length) filteredCount += filterParameters.value.genres.length;
    if (filterParameters.value.reels.length) filteredCount += filterParameters.value.reels.length;
    if (filterParameters.value.lines.length) filteredCount += filterParameters.value.lines.length;
    return filteredCount;
});
const filteredGamesCount = ref<number>(totalCount.value);
const filterButtonLabel = computed(() => {
    switch (filteredGamesCount.value) {
        case 1:
            return "1 hru";
        case 2:
        case 3:
        case 4:
            return `${filteredGamesCount.value} hry`;
        default:
            return `${filteredGamesCount.value} her`;
    }
});

const getInitialFilterParams = () => ({
    genres: [],
    manufacturers: [],
    lines: [],
    reels: [],
    getCountOnly: false,
    sortType: filterParameters.value.sortType,
    pageSize: filterParameters.value.pageSize,
    page: 1,
});
const temporaryFilterParameters = ref<GamesFilterParameters>(getInitialFilterParams());

const toggleSort = () => {
    isSortOpen.value = !isSortOpen.value;
};

const closeSort = () => {
    isSortOpen.value = false;
};

const openFilter = () => {
    closeSort();
    temporaryFilterParameters.value = { ...filterParameters.value };
    temporaryFilterParameters.value.getCountOnly = true;
    filteredGamesCount.value = totalCount.value;
    isFilterOpen.value = true;
};

const isFilterClosing = ref(false);
const closeFilter = async () => {
    isFilterClosing.value = true;
    await bottomSheet.hideAndDestroy();

    isFilterOpen.value = false;
    isFilterClosing.value = false;
    temporaryFilterParameters.value = getInitialFilterParams();
    GamesAnalytics.pushMobileFilterClosed();
};

const clickApplyFilter = async () => {
    filterParameters.value.genres = temporaryFilterParameters.value.genres;
    filterParameters.value.manufacturers = temporaryFilterParameters.value.manufacturers;
    filterParameters.value.lines = temporaryFilterParameters.value.lines;
    filterParameters.value.reels = temporaryFilterParameters.value.reels;
    await reloadWithFilter();
    closeFilter();
};

const updateFilter = async (type: GamesFilterType, item: GamesFilterCategory) => {
    const allAppliedFilterNames = GamesAnalytics.getFilterOptionNames(
        temporaryFilterParameters.value.genres,
        temporaryFilterParameters.value.manufacturers,
        temporaryFilterParameters.value.reels,
        temporaryFilterParameters.value.lines,
        filterOptions.value
    );

    if (temporaryFilterParameters.value[type].includes(item.guid)) {
        GamesAnalytics.pushFilterApplied(type, item.name, allAppliedFilterNames);
    } else {
        GamesAnalytics.pushFilterRemoved(type, [item.name], allAppliedFilterNames);
    }

    filteredGamesCount.value = await getFilteredGamesCount(temporaryFilterParameters.value);
};

const clickResetFilter = async () => {
    const filtersToRemove = GamesAnalytics.getFilterOptionNames(
        temporaryFilterParameters.value.genres,
        temporaryFilterParameters.value.manufacturers,
        temporaryFilterParameters.value.reels,
        temporaryFilterParameters.value.lines,
        filterOptions.value
    );
    GamesAnalytics.pushFilterRemoved(null, filtersToRemove, []);
    temporaryFilterParameters.value = getInitialFilterParams();
    filteredGamesCount.value = await getFilteredGamesCount(temporaryFilterParameters.value);
};

bottomSheet.onSheetClosed(() => {
    closeFilter();
});

watch(isFilterOpen, (isOpen) => {
    if (isOpen) {
        nextTick(() => {
            bottomSheet.create(bottomSheetRef.value.clientHeight);
        });
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(DsButton, {
        type: "interaction",
        size: "sm",
        theme: "dark",
        "icon-left": "filter",
        "aria-label": "Otevřít filtr",
        onClick: openFilter
      }),
      (activeFilterCount.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(activeFilterCount.value), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["games-filter__option games-filter__option--sort", { 'games-filter__option--open': isSortOpen.value }])
    }, [
      _createVNode(DsButton, {
        type: "interaction",
        size: "sm",
        theme: "dark",
        "icon-left": "sort-by",
        "aria-label": "Seřadit hry",
        onClick: toggleSort
      }),
      (isSortOpen.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(GamesSortOptions, { onSortApplied: closeSort })
          ]))
        : _createCommentVNode("", true)
    ], 2),
    _withDirectives(_createElementVNode("div", {
      id: "games-filter-bottom-sheet",
      ref_key: "bottomSheetRef",
      ref: bottomSheetRef,
      class: "games-filter__popup-wrapper"
    }, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(DsButton, {
          type: "interaction",
          size: "sm",
          theme: "dark",
          "icon-left": "cross",
          "aria-label": "Zavřít filtr",
          onClick: closeFilter,
          class: "games-filter__popup-close"
        }),
        (_unref(filterOptions))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _cache[8] || (_cache[8] = _createElementVNode("h3", { class: "games-filter__popup__title" }, "Žánr", -1)),
              _createVNode(GamesFilterCategoryOptions, {
                class: "games-filter__popup-options",
                options: _unref(filterOptions).genres,
                modelValue: temporaryFilterParameters.value.genres,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((temporaryFilterParameters.value.genres) = $event)),
                name: _unref(GamesFilterType).Genres,
                onFilterChanged: _cache[1] || (_cache[1] = (item) => updateFilter(_unref(GamesFilterType).Genres, item))
              }, null, 8, ["options", "modelValue", "name"]),
              _cache[9] || (_cache[9] = _createElementVNode("h3", { class: "games-filter__popup__title" }, "Výrobce", -1)),
              _createVNode(GamesFilterCategoryOptions, {
                class: "games-filter__popup-options",
                options: _unref(filterOptions).manufacturers,
                modelValue: temporaryFilterParameters.value.manufacturers,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((temporaryFilterParameters.value.manufacturers) = $event)),
                name: _unref(GamesFilterType).Manufacturers,
                onFilterChanged: _cache[3] || (_cache[3] = (item) => updateFilter(_unref(GamesFilterType).Manufacturers, item))
              }, null, 8, ["options", "modelValue", "name"]),
              _cache[10] || (_cache[10] = _createElementVNode("h3", { class: "games-filter__popup__title" }, "Počet válců", -1)),
              _createVNode(GamesFilterCategoryOptions, {
                class: "games-filter__popup-options",
                options: _unref(filterOptions).reels,
                modelValue: temporaryFilterParameters.value.reels,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((temporaryFilterParameters.value.reels) = $event)),
                name: _unref(GamesFilterType).Reels,
                onFilterChanged: _cache[5] || (_cache[5] = (item) => updateFilter(_unref(GamesFilterType).Reels, item))
              }, null, 8, ["options", "modelValue", "name"]),
              _cache[11] || (_cache[11] = _createElementVNode("h3", { class: "games-filter__popup__title" }, "Počet linií", -1)),
              _createVNode(GamesFilterCategoryOptions, {
                class: "games-filter__popup-options",
                options: _unref(filterOptions).lines,
                modelValue: temporaryFilterParameters.value.lines,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((temporaryFilterParameters.value.lines) = $event)),
                name: _unref(GamesFilterType).Lines,
                onFilterChanged: _cache[7] || (_cache[7] = (item) => updateFilter(_unref(GamesFilterType).Lines, item))
              }, null, 8, ["options", "modelValue", "name"])
            ], 64))
          : _createCommentVNode("", true)
      ])
    ], 512), [
      [_vShow, isFilterOpen.value]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_6, [
      _createElementVNode("button", {
        class: "games-button",
        disabled: !filteredGamesCount.value,
        onClick: clickApplyFilter
      }, [
        _createElementVNode("span", _hoisted_8, "Zobrazit " + _toDisplayString(filterButtonLabel.value), 1)
      ], 8, _hoisted_7),
      _createVNode(DsButton, {
        class: "games-filter__popup-footer-reset-button",
        size: "lg",
        type: "text",
        theme: "dark",
        onClick: clickResetFilter
      }, {
        default: _withCtx(() => _cache[12] || (_cache[12] = [
          _createTextVNode("Resetovat filtr")
        ])),
        _: 1,
        __: [12]
      })
    ], 512), [
      [_vShow, isFilterOpen.value && !isFilterClosing.value]
    ])
  ]))
}
}

})